export default __webpack_public_path__ + "assets/webgl/SidewallFire_sheet.b969aba6.jpg";